export const getLiveTrackingUrl = (token) => `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOSTNAME}/live/track/${token}`;

export const parseTokenFromHash = (hash) => hash.replace('#', '');

export const parseTokenFromParam = (url) => url.split('=')[1];

export const getTokenFromUrl = () => {
  if (window.location.hash) {
    return parseTokenFromHash(window.location.hash);
  } else {
    return parseTokenFromParam(window.location.href);
  }
}
